export interface ISST_FORMULA {
  salesServiceTax: string;
  rateSales: number;
  rateService: number;
  amount: number;
  inclusiveSST: number;
}

export const SST_FORMULA = ({
  salesServiceTax,
  rateSales,
  rateService,
  amount,
  inclusiveSST,
}: ISST_FORMULA) => {
  const tax = String(salesServiceTax);
  const salesRate = Number(rateSales);
  const serviceRate = Number(rateService);
  const rmAmount = Number(amount);
  const inclusive = Number(inclusiveSST);
  if (rmAmount < 0 || rmAmount > 1e10) {
    const resEmpty = 0;
    return {
      taxAmount: resEmpty,
      salesValue: resEmpty,
      totalAmount: resEmpty,
    };
  }
  const rate = tax == 'sales' ? salesRate / 100 : serviceRate / 100;
  let taxAmount = 0,
    salesValue = 0,
    totalAmount = 0;
  if (inclusive == 0) {
    taxAmount = (rate / (1 + rate)) * rmAmount;
    salesValue = rmAmount - taxAmount;
    totalAmount = rmAmount;
  } else if (inclusive == 1) {
    taxAmount = rate * rmAmount;
    salesValue = rmAmount;
    totalAmount = taxAmount + salesValue;
  }
  return {
    taxAmount: taxAmount.toFixed(2),
    salesValue: salesValue.toFixed(2),
    totalAmount: totalAmount.toFixed(2),
  };
};
